import { Injectable } from '@angular/core';
import { Roles } from '@tix/auth/state';
import { TixStaffService } from '@tix/staff/state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export enum EventPermission {
  ViewEventList,
  ViewEventCalendar,
  AddSingleEvent,
  AddMultipleEvents,
  ViewEventDetails,
  EditEventDetails,
  EditEventDate,
  DeleteEvent,
  CloneEvent,
  AddTicketConfigurations,
  EditTicketConfigurations,
  DeleteTicketConfigurations,
  AddAddOns,
  EditAddOns,
  DeleteAddOns,
  AddMedia,
  EditMedia,
  DeleteMedia,
  AddSocialMedia,
  EditSocialMedia,
  DeleteSocialMedia,
  AddCommunicationTemplate,
  EditCommunicationTemplate,
  DeleteCommunicationTemplate,
  EditSendEmailCommunications,
  EditDailyEventReport,
  AddEventAdmins,
  DeleteEventAdmins,
  EnableCampaignTracking,
  EditCampaignTracking,
  DeleteCampaignTracking,
  ImportCustomers
}

const permissionRoleMapping = new Map<EventPermission, Roles[]>();

permissionRoleMapping.set(EventPermission.ViewEventList, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.EVENT_ADMINISTRATOR,
  Roles.BO_USER
]);
permissionRoleMapping.set(EventPermission.ViewEventCalendar, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.EVENT_ADMINISTRATOR,
  Roles.BO_USER
]);
permissionRoleMapping.set(EventPermission.AddSingleEvent, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER
]);
permissionRoleMapping.set(EventPermission.AddMultipleEvents, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER
]);
permissionRoleMapping.set(EventPermission.ViewEventDetails, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.EVENT_ADMINISTRATOR,
  Roles.BO_USER
]);
permissionRoleMapping.set(EventPermission.EditEventDetails, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.EditEventDate, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER
]);
permissionRoleMapping.set(EventPermission.DeleteEvent, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER
]);
permissionRoleMapping.set(EventPermission.CloneEvent, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER
]);
permissionRoleMapping.set(EventPermission.AddTicketConfigurations, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.EditTicketConfigurations, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.DeleteTicketConfigurations, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.AddAddOns, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.EditAddOns, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.DeleteAddOns, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.AddMedia, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.EditMedia, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.DeleteMedia, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.AddSocialMedia, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.EditSocialMedia, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.DeleteSocialMedia, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.AddCommunicationTemplate, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.EditCommunicationTemplate, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.DeleteCommunicationTemplate, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.EditSendEmailCommunications, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.EditDailyEventReport, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.AddEventAdmins, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER
]);
permissionRoleMapping.set(EventPermission.DeleteEventAdmins, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.EnableCampaignTracking, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.EditCampaignTracking, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.DeleteCampaignTracking, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER,
  Roles.EVENT_ADMINISTRATOR
]);
permissionRoleMapping.set(EventPermission.ImportCustomers, [
  Roles.CO_ADMIN,
  Roles.MANAGER,
  Roles.BO_USER
]);

function oneOfRolesIsAssigned(assignedRoles: Roles[], wantedRoles: Roles[]) {
  for (const role of wantedRoles) {
    if (assignedRoles.includes(role)) return true;
  }

  return false;
}

@Injectable({
  providedIn: 'root'
})
export class EventAccessService {
  constructor(private staffService: TixStaffService) {}

  private getUserRoles(companyId: string) {
    return this.staffService.getCurrentUserRolesInCompany(companyId);
  }

  hasPermission(
    permission: EventPermission,
    companyId: string
  ): Observable<boolean> {
    return this.getUserRoles(companyId).pipe(
      map(roles => {
        const rolesWithPermission = permissionRoleMapping.get(permission);

        if (!rolesWithPermission)
          throw new Error(
            'No mapping found for the event permission: ' + permission
          );

        return oneOfRolesIsAssigned(roles, rolesWithPermission);
      })
    );
  }
}
